export default {
    current_choice: 'Aktuellt val',
    book_now: 'Boka nu',
    minimum_age: 'Endast personer över {age}',
    excess_liability: 'Självrisk',
    security_deposit: 'Säkerhetsdeposition',
    fuel_policy: 'Bränslepolicy',
    like_for_like: 'Lika för lika',
    full_to_full: 'Full till full',
    miles_per_rental: '{mileage} gratis miles per hyrning',
    km_per_rental: '{mileage} gratis km per hyrperiod',
    unlimited_mileage: 'Obegränsat milantal',
    unlimited_mileage_km: 'Obegränsade km',
    non_amendable: 'Kan ej ändras',
    non_refundable: 'Kan ej återbetalas',
    free_cancellation_until: 'Gratis avbokning fram till',
    cancellation_in_line_with: 'Avbokning i linje med',
    tcs: 'villkor',
    free_extras_on_collection: 'Två gratis tillval vid hämtning',
    glass_and_tyres_covered: 'Glas och däck täcks',
    number_of_passengers: 'Antal passagerare',
    number_of_bags: 'Antal väskor',
    fuel_type: 'Bränsletyp',
    co2: 'CO2',
    aircon: 'Air con',
    transmission: 'Växellåda',
    book_type: 'Boka {type}',
    debit_card_deposit: 'Betalkort accepteras för insättningar',
    fast_track_included: 'Snabbspår ingår',
}
